module.exports = __webpack_public_path__ + "static/media/banner_4.57880ab5.jpg";